import { DeliveryNote, DeliveryNoteTypes } from '../types/delivery-note.type';

export interface GroupedDeliveryNotes {
  home: DeliveryNote[];
  deliveryPoint: DeliveryNote[];
  eco: DeliveryNote[];
}

export function groupDeliveryNotesByType(deliveryNotes: DeliveryNote[]): GroupedDeliveryNotes {
  return {
    home: deliveryNotes.filter((note) => note.type === DeliveryNoteTypes.HOME),
    deliveryPoint: deliveryNotes.filter((note) => note.type === DeliveryNoteTypes.DELIVERY_POINT),
    eco: deliveryNotes.filter((note) => note.type === DeliveryNoteTypes.ECO),
  };
}
